export var Tag;
(function (Tag) {
    Tag["LP_TOKEN"] = "lp-token";
})(Tag || (Tag = {}));
export var ChainId;
(function (ChainId) {
    ChainId[ChainId["MAINNET"] = 101] = "MAINNET";
    ChainId[ChainId["TESTNET"] = 102] = "TESTNET";
    ChainId[ChainId["DEVNET"] = 103] = "DEVNET";
})(ChainId || (ChainId = {}));
export var UTLSource;
(function (UTLSource) {
    UTLSource["API"] = "API";
    UTLSource["CHAIN"] = "CHAIN";
    UTLSource["METADATA"] = "METADATA";
})(UTLSource || (UTLSource = {}));
